import React, { Component } from 'react';
import { noop } from 'lodash';
import { changeColorTint } from '../../../styles/utils';

class SimpleMarker extends Component {
  render() {
    const { onMouseEnter, onMouseLeave, visible } = this.props;
    return (
      <div
        style={{
          backgroundColor: this.props.color,
          borderColor: this.props.color ? changeColorTint(this.props.color, -50) : null,
          display: visible ? 'block' : 'none',
        }}
        className={`marker circleMarker ${this.props.focused && 'focused'} ${
          this.props.noShadow && 'no-shadow'
        }`}
        onMouseEnter={onMouseEnter || noop}
        onMouseLeave={onMouseLeave || noop}
      />
    );
  }
}

export default SimpleMarker;
